"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYoutubeEmbedUrl = getYoutubeEmbedUrl;
exports.extractYoutubeId = extractYoutubeId;
exports.getYoutubeThumbnail = getYoutubeThumbnail;
/**
 * @name getYoutubeEmbedUrl
 * @description 유튜브 링크를 embed URL로 변환
 * @param {string} url - 유튜브 링크 (watch, shorts, youtu.be 형식 지원)
 * @returns {string} - embed 형식의 URL
 * @example
 */
function getYoutubeEmbedUrl(url) {
    if (!url)
        return '';
    // youtube.com/watch?v= 형식
    const watchMatch = url.match(/[?&]v=([^&]+)/);
    if (watchMatch) {
        return `https://www.youtube.com/embed/${watchMatch[1]}`;
    }
    // youtu.be/ 형식
    const shortMatch = url.match(/youtu\.be\/([^?]+)/);
    if (shortMatch) {
        return `https://www.youtube.com/embed/${shortMatch[1]}`;
    }
    return url;
}
/**
 * @name extractYoutubeId
 * @description 유튜브 URL에서 비디오 ID 추출
 * @param {string} url - 유튜브 링크
 * @returns {string | null} - 비디오 ID 또는 null
 */
function extractYoutubeId(url) {
    const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
}
/**
 * @name getYoutubeThumbnail
 * @description 유튜브 비디오 썸네일 URL 생성
 * @param {string} url - 유튜브 링크
 * @param {string} quality - 썸네일 품질 (default, hq, mq, sd, maxres)
 * @returns {string} - 썸네일 URL
 */
function getYoutubeThumbnail(url, quality = 'maxres') {
    const videoId = extractYoutubeId(url);
    if (!videoId)
        return '';
    const qualityMap = {
        default: 'default.jpg',
        hq: 'hqdefault.jpg',
        mq: 'mqdefault.jpg',
        sd: 'sddefault.jpg',
        maxres: 'maxresdefault.jpg',
    };
    return `https://img.youtube.com/vi/${videoId}/${qualityMap[quality] || qualityMap.maxres}`;
}
